export function statusUserColor(status: 'online' | 'instability' | 'offline'){
  const pallet = {
    'online': 'success',
    'instability': 'warning',
    'offline': 'error',
  }
  return pallet[status] as 'success' | 'warning' | 'error' | 'default' | 'primary' | 'secondary' | 'info';
}